exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fixed-posters-action[data-v-94306872]{width:100%;margin-right:auto;margin-left:auto;position:fixed;bottom:0;color:#354558;left:0;background-color:#fff}.posters-actions[data-v-94306872]{display:flex;align-items:center;padding:15px 2.5vw}@media screen and (max-width:768px){.fixed-posters-action[data-v-94306872]{padding-left:0;width:100%}.posters-actions[data-v-94306872]{padding:15px}}.btn-info[data-v-94306872]{background-color:#5d82d1;border-color:#2e6da4}.btn-info[data-v-94306872]:hover{background-color:#286090;border-color:#204d74}.warning-text[data-v-94306872]{font-size:13px;font-family:Montserrat}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-94306872","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/PostersActions.vue
// module id = TP9f
// module chunks = 101